module.exports = __webpack_public_path__ + "static/media/envelope.829813e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/envelope.svg
// module id = 1046
// module chunks = 46